import { Box, Button, Container, useMediaQuery } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Config from "Config";
import { useTranslation } from "react-i18next";
import { Link, useSearchParams } from "react-router-dom";
import Header from "../../component/Header/Header";
import PortalNavbar from "../../component/PortalNavbar/PortalNavbar";
import clo_icon from "../../images/clo.jpg";
import edb_icon from "../../images/EDBLogin.jpg";
import sslo_icon from "../../images/ngo.jpg";
import public_icon from "../../images/public.jpg";
import { isEmpty } from "../../Utils";
import "./LoginPage.scss";
const useStyles = makeStyles({
    root: {
        width: "85%",
        height: "100%",
        margin: "6px 100px 0px 50px",
        flex: 1,
    },
    rootMobile: {
        margin: "6px 0px 0px 0px",
        flex: 1,
    },
    label: {
        flexDirection: "column",
        fontSize: "15px",
    },
    buttonColor: {
        backgroundColor: "white",
        color: "black",
        height: "150px",
        width: "150px",
        marginBottom: "35px",
        "&:hover": {
            backgroundColor: "#F39C12",
            color: "white",
        },
    },
});

function Login({ edb = false }) {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const matches = useMediaQuery("(min-width:600px)");
    const [searchParams, setSearchParams] = useSearchParams();
    const redirect = searchParams.get("redirect");
    localStorage.removeItem("login_redirect");
    return (
        <Container maxWidth="md">
            {/* <Notifaction fixed edb={edb} closedButton /> */}
            <Header
                headerTitle={t("common.sideNavList.login")}
                className="header"
                edb={edb}
                cangreyScreen={!edb} // Only Loginpage can gray screen
            ></Header>
            <Box className={`container ${edb ? "" : "greyScreen"}`}>
                <PortalNavbar aside className="drawer" />
                <Box className="main">
                    <Box id="main-content" className="active"></Box>
                    <Box
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column",
                            height: "100%",
                        }}
                    >
                        {!edb && (
                            <>
                                {Config.DISPLAY_CLO_LOGIN && (
                                    <Button
                                        classes={{
                                            root: classes.buttonColor,
                                            label: classes.label,
                                        }}
                                        className="buttons"
                                        onClick={() => {
                                            if (redirect)
                                                localStorage.setItem(
                                                    "login_redirect",
                                                    "/eformss" + redirect
                                                );
                                            window.location.href = `${Config.CLO_LOGIN}`;
                                        }}
                                        variant="contained"
                                        color="primary"
                                    >
                                        <img
                                            src={clo_icon}
                                            alt=""
                                            style={{ height: "100px" }}
                                        />
                                        CLO {t("common.sideNavList.login")}
                                    </Button>
                                )}
                                <Button
                                    classes={{
                                        root: classes.buttonColor,
                                        label: classes.label,
                                    }}
                                    className="buttons"
                                    variant="contained"
                                    color="primary"
                                    component={Link}
                                    to={`/loginSSLO${
                                        isEmpty(redirect)
                                            ? ""
                                            : `?redirect=${redirect}`
                                    }`}
                                    onClick={() => {
                                        if (redirect)
                                            localStorage.setItem(
                                                "login_redirect",
                                                "/eformss" + redirect
                                            );
                                    }}
                                >
                                    <img
                                        src={sslo_icon}
                                        alt=""
                                        style={{ height: "100px" }}
                                    />
                                    SSLO {t("common.sideNavList.login")}
                                </Button>
                                <Button
                                    classes={{
                                        root: classes.buttonColor,
                                        label: classes.label,
                                    }}
                                    className="buttons"
                                    variant="contained"
                                    color="primary"
                                    component={Link}
                                    to={`/loginPublic${
                                        isEmpty(redirect)
                                            ? ""
                                            : `?redirect=${redirect}`
                                    }`}
                                    onClick={() => {
                                        if (redirect)
                                            localStorage.setItem(
                                                "login_redirect",
                                                "/eformss" + redirect
                                            );
                                    }}
                                >
                                    <img
                                        src={public_icon}
                                        alt=""
                                        style={{ height: "100px" }}
                                    />

                                    {t("common.portal.publicLogin")}
                                </Button>
                            </>
                        )}
                        {edb && (
                            <Button
                                classes={{
                                    root: classes.buttonColor,
                                    label: classes.label,
                                }}
                                className="buttons"
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    if (redirect)
                                        localStorage.setItem(
                                            "login_redirect",
                                            "/eformss" + redirect
                                        );
                                    window.location.href = `${Config.EDB_LOGIN}`;
                                }}
                            >
                                <img
                                    src={edb_icon}
                                    alt=""
                                    style={{ height: "100px" }}
                                />
                                EDB {t("common.sideNavList.login")}
                            </Button>
                        )}
                    </Box>
                </Box>
            </Box>
        </Container>
    );
}
export default Login;
